/**
 * @generated SignedSource<<2a1a1093397c99487e96403a92ef346a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountList_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccount_viewer">;
  readonly " $fragmentType": "CheckoutBankAccountList_viewer";
};
export type CheckoutBankAccountList_viewer$key = {
  readonly " $data"?: CheckoutBankAccountList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountList_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountList_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccount_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d69667d04c2f87eb925d604349cd18dd";

export default node;
